<h1 mat-mdc-dialog-title>Select customer</h1>
<div class="dialog-content" style="height: 400px">
  <form [formGroup]="theForm" novalidate [@formState]="state">
    <mat-form-field style="width: 100%;">
      <mat-icon matPrefix>supervisor_account</mat-icon>
      <input matInput placeholder="{{ 'turbo.dialog.impersonate.searchBox' |translate:'Search for user'}}" [disabled]="isWorking" formControlName="searchText" (change)="updateFilter()" (keyup)="updateFilter()" />
    </mat-form-field>

    <mat-list style="height: 293px;">
      <mat-list-item [ngClass]="{'active': selectedLocation == location}" (click)="selectLocation(location)" *ngFor="let location of filteredLocations">{{ location.XalAccountNo }} - {{ location.DeliveryAddressCustomerName }}</mat-list-item>
    </mat-list>
  </form>
  <div class="confirmationMessage fullscreenMessage" [@successState]="state">
    <mat-icon>assignment_turned_in</mat-icon>
    {{ 'turbo.dialog.impersonate.msgSuccess' |translate:'Now impersonating '}} {{selectedLocation?.Name}}...
  </div>
</div>
<div mat-dialog-actions style="height: 36px; text-align: center; margin-top: 10px">
  <button mat-raised-button color="primary" style="width: 100%;" [disabled]="selectedLocation == undefined" (click)="impersonate()" *ngIf="!isWorking">Select</button>
</div>
<div class="loader" *ngIf="isWorking">
  <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="isWorking"></mat-progress-bar>
</div>
